import { AppRouteProps } from "@harea/component";
import { UserManagementContainer } from "./container/UserManagementContainer";
import { UserOrganisationRoutes } from "views/organisation/UserOrganisationRoutes";
import { UserListRoutes } from "views/list/UserListRoutes";
import { UserDetailsRoutes } from "views/user-details/UserDetailsRoutes";
import { GroupsDetailsRoutes } from "views/organisation/views/groups/views/details/GroupsDetailsRoutes";
import { Outlet } from "react-router-dom";
import { MyAccountRoutes } from "views/my-account/MyAccountRoutes";
import { MyOrganizationRoutes } from "views/my-organization/MyOrganizationRoutes";
import { AdminEmployeeRoutes } from "views/employees/AdminEmployeeRoutes";
import { TaxBracketsRoutes } from "views/tax-brackets/TaxBracketsRoutes";
import { OvertimeRoutes } from "views/overtime/OvertimeRoutes";
import { OvertimeRateRoutes } from "views/overtime-rate/OvertimeRateRoutes";
import { HierarchyRoutes } from "views/hierarchy/HierarchyRoutes";

export const UserManagementRoutes: Array<AppRouteProps> = [
  {
    path: "",
    element: <UserManagementContainer />,
    children: [
      ...MyAccountRoutes,
      ...MyOrganizationRoutes,
      ...UserOrganisationRoutes,
      ...UserListRoutes,
      ...UserDetailsRoutes,
      ...AdminEmployeeRoutes,
      ...TaxBracketsRoutes,
      ...OvertimeRoutes,
      ...OvertimeRateRoutes,
      ...HierarchyRoutes,
    ],
  },

  {
    path: "",
    element: <Outlet />,
    children: [...GroupsDetailsRoutes],
  },
];
